import { isEmpty } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import calendar from '../../assets/light_theme_images/calender.svg';
import clock from '../../assets/light_theme_images/clock.svg';
import { convertToAmPm, convertToDate } from '../../common/commonFunction';
import withRouter from '../../components/Common/withRouter';
import EventView from '../../components/Event/View';
import { pushViewEvent } from '../../seo/gtevents';
import SeoDetails from '../../seo/SeoDetails';
import ChipFilter from '../Home/components/ChipFilter';
import useOnlineEvents from './hooks/useOnlineEvents';

const OnlineEvents = (props) => {
    const {
        events,
        totalEvents,
        swiperRef,
        loadMore,
        handlePageClick,
        seoData,
    } = useOnlineEvents(props.router);

    return (
        <>
            <SeoDetails
                title={seoData?.seo_title}
                description={seoData?.seo_description}
                ogImage={seoData?.seo_image}
                keywords={seoData?.keywords}
            />

            <ChipFilter props={props} />

            <section className="bg-white py-16">
                <div className="container">
                    <div className="mb-6">
                        <h1 className="text-base md:text-3xl font-bold text-[#212121] capitalize line-clamp-1">
                            Online Events
                        </h1>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4 lg:gap-5">
                        {events.map((singleEvent, index) => (
                            <Link key={index} to={`/events/${singleEvent.slug}`}>
                                <EventView singleEvent={singleEvent} />
                            </Link>
                        ))}
                    </div>
                    {events.length === 0 && (
                        <div className="text-center text-black">
                            <h2 className="text-2xl font-body font-normal text-center">
                                No Events Found
                            </h2>
                        </div>
                    )}
                    {events.length < totalEvents && (
                        <div className="text-center text-black mt-10">
                            <button
                                onClick={loadMore}
                                className="border border-red-600 text-red-600 py-2 px-4 rounded-lg"
                            >
                                Load more
                            </button>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
};

export default withRouter(OnlineEvents);
